export type Invitation = {
  id: string;
  fromUserId: string;
  inviteeEmail: string;
  type: InvitationType;
  destinationId: string;
  access: InvitationAccess;
  status: InvitationStatus;
  expiresAt: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
};

export type InvitationWithDestinationDetails = Invitation & {
  fromUserName: string;
  destinationName: string;
};

export enum InvitationType {
  Household = 'household',
  Business = 'business',
}

export enum InvitationStatus {
  New = 'new',
  Accepted = 'accepted',
  Declined = 'declined',
  Void = 'void',
}

export enum InvitationAccess {
  Read = 'read',
  Write = 'write',
}
